import React from 'react';
import { Icon } from '@lnr-v2/ui';
import styles from './TagPill.module.css';

export interface TagPillProps {
  label: string;
  color?: string;
  icon?: string;
  size?: 'sm' | 'md' | 'lg';
  removable?: boolean;
  onRemove?: () => void;
  onClick?: () => void;
  className?: string;
}

export const TagPill: React.FC<TagPillProps> = ({
  label,
  color,
  icon,
  size = 'md',
  removable = false,
  onRemove,
  onClick,
  className,
}) => {
  const style = color
    ? ({
        '--tag-color': color,
        backgroundColor: `${color}15`,
        borderColor: `${color}40`,
        color: color,
      } as React.CSSProperties)
    : {};

  return (
    <span
      className={`${styles.pill} ${styles[size]} ${onClick ? styles.clickable : ''} ${className || ''}`}
      style={style}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {icon && <Icon name={icon} size="sm" className={styles.icon} />}
      <span className={styles.label}>{label}</span>
      {removable && onRemove && (
        <button
          type="button"
          className={styles.removeButton}
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          aria-label="Remove tag"
        >
          <Icon name="x" size="sm" className={styles.removeIcon} />
        </button>
      )}
    </span>
  );
};
